import { ApplicationView } from '@aha-app/mvc';
import React, { useState } from 'react';
import { isFrame } from '../objects/guards';
import ToolButton from '../toolbars/ToolButton';
import Tool, {
  type IToolActionInput,
  type IToolAvailableInput,
  type ToolButtonComponent,
} from './Tool';

const ToggleFrameVisibilityButton: ToolButtonComponent = ApplicationView(
  ({ selection }) => {
    const frames = selection.getObjects().filter(isFrame);
    const [visible, setVisible] = useState(
      frames.some(obj => obj.getFrameVisibility())
    );

    const toolName = `${visible ? 'Hide' : 'Show'} frame${
      frames.length > 1 ? 's' : ''
    } when presenting`;

    return (
      <span>
        <ToolButton
          tool={ToolFrameVisibility}
          name={toolName}
          onClick={() => {
            setVisible(!visible);
            for (const frame of frames) {
              frame.setFrameVisibility(!visible);
            }
          }}
        >
          <i
            className={
              visible ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash'
            }
          />
        </ToolButton>
      </span>
    );
  }
);

class ToolFrameVisibility extends Tool {
  static toolName = 'Toggle visibility in frame navigation';

  static action({ selection }: IToolActionInput) {
    const frames = selection.getObjects().filter(isFrame);
    const visible = !frames[0].getFrameVisibility();
    for (const frame of frames) {
      frame.setFrameVisibility(visible);
    }
  }

  static available({ selection }: IToolAvailableInput) {
    return !!selection?.getObjects().every(isFrame);
  }

  static buttonComponent() {
    return ToggleFrameVisibilityButton;
  }
}

export { ToolFrameVisibility };
